module.exports = function() {
  return new Worker(__webpack_public_path__ + "612685c3224c06ca1414.worker.js");
};